import Vue from 'vue'
import VueRouter from 'vue-router'
import authService from '../helpers/authService'
import store from '../store'

import LoginPage from '../views/LoginPage'
import HomePage from '../views/HomePage'
import NotFoundPage from '../views/NotFoundPage'
import ResetPasswordPage from '../views/ResetPasswordPage'

Vue.use(VueRouter)

var authenticationCheck = (to, from, next) => {
  authService.getSession()
    .then((r) => {
      const userInfo = store.getters['loginModule/userInfo']

      if (to.meta && to.meta.module) {
        store.commit('changeAppModule', to.meta.module)
      } else {
        store.commit('changeAppModule', '')
      }

      if (!userInfo || !userInfo.isAuthenticated) {
        if (!to.meta.isPrivate) {
          next()
          return
        }
        next({ path: '/login', query: { redirect: to.fullPath } })
        store.commit('changeAppModule', '')
        return
      }

      if (to.name === 'login') {
        next({ path: '/' })
        store.commit('changeAppModule', '')
        return
      }

      if (to.meta && to.meta.module) {
        if (!userInfo.apps || userInfo.apps.findIndex(a => a.code === to.meta.module) === -1) {
          store.commit('changeAppModule', '')
          next({ name: 'notFound' })
          return
        }
      }

      next()
    })
}

const routes = [
  { path: '/login', name: 'login', component: LoginPage },
  { path: '/', name: 'home', component: HomePage, meta: { isPrivate: true } },
  { path: '/resetpassword/:token', props: true, name: 'resetPassword', component: ResetPasswordPage },
  // Auctions
  { path: '/auctions', redirect: 'auctions/open' },
  { path: '/auctions/open', name: 'openAuctions', component: () => import(/* webpackChunkName: "OpenAuctionsPage" */ '../views/Auctions/OpenAuctionsPage.vue'), meta: { isPrivate: true, module: 'auctions' } },
  { path: '/auctions/assigned', name: 'assignedAuctions', component: () => import(/* webpackChunkName: "AssignedAuctionsPage" */ '../views/Auctions/AssignedAuctionsPage.vue'), meta: { isPrivate: true, module: 'auctions' } },
  { path: '/auctions/history', name: 'auctionsHistory', component: () => import(/* webpackChunkName: "AuctionsHistoryPage" */ '../views/Auctions/AuctionsHistoryPage.vue'), meta: { isPrivate: true, module: 'auctions' } },
  // PurchaseOrders
  { path: '/purchaseOrders', name: 'purchaseOrders', component: () => import(/* webpackChunkName: "PurchaseOrdersPage" */ '../views/PurchaseOrders/PurchaseOrdersPage.vue'), meta: { isPrivate: true, module: 'purchaseOrders' } },
  { path: '/purchaseOrders/payments', name: 'payments', component: () => import(/* webpackChunkName: "PaymentsPage" */ '../views/PurchaseOrders/PaymentsPage.vue'), meta: { isPrivate: true, module: 'purchaseOrders' } },
  // EDI
  { path: '/edi/releases', name: 'ediReleases', component: () => import(/* webpackChunkName: "EdiReleasesPage" */ '../views/EDI/ReleasesPage.vue'), meta: { isPrivate: true, module: 'edi' } },
  { path: '/edi/shipments/newcapture', name: 'ediShipNewCapture', component: () => import(/* webpackChunkName: "NewCapturePage" */ '../views/EDI/NewCapturePage.vue'), meta: { isPrivate: true, module: 'edi' } },
  { path: '/edi/shipments/Consignment', name: 'consignment', component: () => import(/* webpackChunkName: "NewCapturePage" */ '../views/EDI/Consignment.vue'), meta: { isPrivate: true, module: 'edi' } },

  { path: '/edi/shipments/pendings', name: 'ediShipPendings', component: () => import(/* webpackChunkName: "PendingShipmentsPage" */ '../views/EDI/PendingShipmentsPage.vue'), meta: { isPrivate: true, module: 'edi' } },
  { path: '/edi/invoices', name: 'ediInvoices', component: () => import(/* webpackChunkName: "PendingShipmentsPage" */ '../views/EDI/InvoicesPage2.vue'), meta: { isPrivate: true, module: 'edi' } },

  { path: '*', name: 'notFound', component: NotFoundPage }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach(authenticationCheck)

export default router
